// // import * as React from 'react';
// // import Box from '@mui/material/Box';
// // import { styled, alpha } from '@mui/material/styles';
// // import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
// // import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem';
// // import { TreeViewBaseItem } from '@mui/x-tree-view/models';                        
                              
                              
// // const ShowVerticalAlignment = ({periodsData,onSuccess,setShowToastMessage,setObjectiveAsyncOpState,afterSuccess}:any) => {

// // //     const tenantId:string=useSelector((state:any)=>state.meetings.profileTenantId);
// // //     const[showAdvanceOptions,setShowAdvanceOptions]=useState<boolean>(false)

// // //     const{data:teamsOptions,isLoading:teamOPloading}=useGetAllObjectiveDefinitionLevelByTenantId(tenantId);
// // //     const{data:personsOptionds}=useGetAllActivePersonByTenantId(tenantId);
// // //     const{data:submitOptions}=useGetAllObjectiveOKRStateByTenantId(tenantId);
   
// // //     const periodId=useSelector((state:any)=>state.meetings.priodId);
// // // const[periodOptions,setPeriodOptions]=useState<any>([]);
// // // const[horzinalAliIds,setHorzinalAliIds]=useState<any[]>([]);
// // // const[allIds,setAllIds]=useState<any>([]);
// // // const[okrStateId,setOkrStateId]=useState<string>('');
// // // const[lIsPublic,setlIsPublic]=useState<any>(false);
// // // const[showLtoastMessage,setShowLtoastMessage]=useState<any>(null);
// // // const[addObjError,setAddObjError]=useState<any>(null)
// // // const[objNameIds,setObjNameIds]=useState<any>({
// // //   tenantId:tenantId,
// // //   periodId:periodId,
// // //   definitionLevelId:null

// // // })
   
// // //       const{mutate:addObjective,data:addObjectiveData,isSuccess,isLoading}=useAddObjective()



// //       const MUI_X_PRODUCTS = [
// //         {
// //           id: "grid",
// //           label: "Data Grid",
// //           children: [
// //             { id: "grid-community", label: "@mui/x-data-grid" },
// //             { id: "grid-pro", label: "@mui/x-data-grid-pro" },
// //             { id: "grid-premium", label: "@mui/x-data-grid-premium" },
// //           ],
// //         },
// //         {
// //           id: "pickers",
// //           label: "Date and Time Pickers",
// //           children: [
// //             { id: "pickers-community", label: "@mui/x-date-pickers" },
// //             { id: "pickers-pro", label: "@mui/x-date-pickers-pro" },
// //           ],
// //         },
// //         {
// //           id: "charts",
// //           label: "Charts",
// //           children: [{ id: "charts-community", label: "@mui/x-charts" }],
// //         },
// //         {
// //           id: "tree-view",
// //           label: "Tree View",
// //           children: [{ id: "tree-view-community", label: "@mui/x-tree-view" }],
// //         },
// //       ];
      
// //       const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
// //         color:
// //           theme.palette.mode === "light"
// //             ? theme.palette.grey[800]
// //             : theme.palette.grey[200],
// //         [`& .${treeItemClasses.content}`]: {
// //           borderRadius: theme.spacing(0.5),
// //           padding: theme.spacing(0.5, 1),
// //           margin: theme.spacing(0.2, 0),
// //           [`& .${treeItemClasses.label}`]: {
// //             fontSize: "0.8rem",
// //             fontWeight: 500,
// //           },
// //         },
// //         [`& .${treeItemClasses.iconContainer}`]: {
// //           borderRadius: "50%",
// //           backgroundColor:
// //             theme.palette.mode === "light"
// //               ? alpha(theme.palette.primary.main, 0.25)
// //               : theme.palette.primary.dark,
// //           color: theme.palette.mode === "dark" && theme.palette.primary.contrastText,
// //           padding: theme.spacing(0, 1.2),
// //         },
// //         [`& .${treeItemClasses.group}`]: {
// //           marginLeft: 15,
// //           paddingLeft: 18,
// //           borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
// //         },
// //       }));
  


// //   return (
// //     <Box sx={{ minHeight: 352, minWidth: 250 }}>
// //       <RichTreeView
// //         defaultExpandedItems={["grid"]}
// //         //slots={{ item: CustomTreeItem }}
// //         items={MUI_X_PRODUCTS}
// //       />
// //     </Box>
// //   )
// // }

// // export default ShowVerticalAlignment



// import * as React from 'react';
// import {useEffect,useState} from 'react';
// import { useSelector } from 'react-redux';
// import NodeLabel  from './NodeLabel/NodeLabel';
// import Box from '@mui/material/Box';
// // import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
// // import { useTreeItem2Utils } from '@mui/x-tree-view/hooks';
// // import { UseTreeItem2ContentSlotOwnProps } from '@mui/x-tree-view/useTreeItem2';
// // import { TreeItem2,TreeItem2Props } from '@mui/x-tree-view/TreeItem2';
// // import { TreeViewBaseItem } from '@mui/x-tree-view/models';
// import { useGetAllVerticalAlignmentByTenantId } from '../OKRManagment/Hooks/index';
// // import React from "react";
// import ReactDOM from "react-dom";
// import Tree from "react-d3-tree";
// import "./style.css";

// const myTreeData = [
//     {
//         name: "Gaurang Torvekar",
//         children: [
//             {
//                 name: "Avadhoot",
//                 children: [
//                     {
//                         name: "Richard"
//                     },
//                     {
//                         name: "Constantine",
                       
//                     },
//                     {
//                         name: "Daniel"
//                     }
//                 ]
//             },
//             {
//                 name: "Mia"
//             },
//             {
//                 name: "Varun",
//                 children: [
//                     {
//                         name: "Ivo",
//                     },
//                     {
//                         name: "Vijay"
//                     }
//                 ]
//             },
//             {
//                 name: "Mohit"
//             }
//         ]
//     }
// ];
// const svgSquare = {
//     shape: "rect",
//     shapeProps: {
//         width: 180,
//         height: 40,
//         x: 0,
//         y: -20,
//         color: "#ffffff"
//     }
// };
// const test = {
//     shape: "rect",
//     shapeProps: {
//         width: 0,
//         height: 0,
//         x: -20,
//         y: 20,
//         stroke: "#2F80ED"
//     }
// };
// const nodeStyle = (React.createElement("svg", { viewbox: "0 0 100 60", xmlns: "http://www.w3.org/2000/svg" },
//     React.createElement("rect", { width: "80", height: "40", x: "10", y: "10", style: "fill: skyblue; stroke: cadetblue; stroke-width: 2;" })));
// const treeStyle = {
//     nodes: {
//         node: {
//             circle: React.createElement("nodeStyle", null),
//             name: React.createElement("nodeStyle", null),
//             attributes: React.createElement("nodeStyle", null)
//         }
//     }
// };
// interface NodeLabelProps {
//     className: string;
//     nodeData: {
//       name: string;
//     };
//   }
// //   class NodeLabel extends React.PureComponent {
// //     render() {
// //         const { className, nodeData } = this.props;
// //         return (React.createElement("div", { className: className, style: {
// //                 background: "#ffffff",
// //                 height: "70px",
// //                 borderTop: "2px solid #2F80ED",
// //                 textAlign: "center",
// //                 // position: "fixed",
// //                 zIndex: "1000",
// //                 // left: "-10px",
// //                 boxShadow: "0px 10px 10px rgba(0, 0, 0, 0.1)",
// //                 padding: "5px 0",
// //                 borderRadius: "5px"
// //             } }, nodeData.name));
// //     }
// // }
  
//   const ShowVerticalAlignment = ({periodsData} : any) => {
//     const tenantId = useSelector((state: any) => state.meetings.profileTenantId);
//     const period = periodsData.filter((x : any)=>x.isCurrent === true);
//     let{id} = period[0];
//     // const[allObjective,setAllObjective]=useState<any[]>();
//     const { data: objectiveDetailData, isLoading: getObjectiveDetailLoading } = useGetAllVerticalAlignmentByTenantId(id, tenantId);

//     // useEffect(() => {

//     //     setAllObjective(periodsData)
    
//     //   }, [periodsData])

//     let{data } =objectiveDetailData || {};
//     // let{data } =allObjective;

//     return (
//       <div className="App">
//         <h1>همسویی عمودی</h1>
//         <div id="treeWrapper" style={{ width: '100%', height: '100vh' }}>
//           <Tree
//             data={data}
//             //svgClassName ={svgSquare}
//             nodeSvgShape={test}
//             pathFunc="step"
//             separation={{ siblings: 2, nonSiblings: 2 }}
//             orientation="vertical"
//             translate={{ x: 900, y: 100 }}
//             allowForeignObjects
//             nodeLabelComponent={{
//               render: <NodeLabel className="myLabelComponentInSvg" nodeData={{name:''}}/>,
//               foreignObjectWrapper: {
//                 width: 220,
//                 height: 200,
//                 y: -50,
//                 x: -100,
//               },
//             }}
//             initialDepth={0.02}
//           />
//         </div>
//       </div>
//     );
//   };
  
// export default ShowVerticalAlignment
import React, { useState, useEffect, lazy, Suspense } from "react";
import PeriodSlider from "../../components/GlobalComponents/PeriodSlider/PeriodSlider";
import { useSelector } from "react-redux";
import { useGetPriodById } from "../../components/Login/Hooks/Index";
import CircularProgress from "@mui/material/CircularProgress";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  Box,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import TreeAllOKR from "../Reports/LComponent/TreeAllOKR/TreeAllOKR";
import { useGetAllObjectiveByPeriodId1 } from "../Reports/Hooks";


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const Index: React.FC = function () {
  const [value, setValue] = React.useState(0);
  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const setPeriodIdData = (id: string) => {
    setPeriodId(id);
  };

  const onSuccesss = (data: any) => {
    let length = data?.map((e: any) => e.isCurrent).indexOf(true);
    setPeriodId(data[length].id);
    setActiveIndex(length);
  };

  const onFailed = (): void => {};

  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const {
    data: perData,
    isLoading: perLoading,
    isError: periodError,
    isFetched,
  }: any = useGetPriodById(tenantId, onSuccesss, onFailed);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [periodId, setPeriodId] = useState<string | null>(null);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const onSuccesssGetAllObjectiveData2 = (data: any) => {
  };
 
  const{data:objetcideData1,isLoading:getObjectiveLoading1,refetch:getObjectivesAgain1}=useGetAllObjectiveByPeriodId1(periodId,tenantId,onSuccesssGetAllObjectiveData2)
  return (
    <>
      <PeriodSlider
        setActiveIndex={setActiveIndex}
        setPriodId={setPeriodId}
        activeIndex={activeIndex}
        tenantId={tenantId}
        slideData={perData}
        dataLoading={perLoading}
      />
      <Grid container>
        <Grid item xs={12} md={12}>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label="درخت OKR"
                  {...a11yProps(0)}
                  style={{ color: "black", fontWeight: "700" }}
                />
              </Tabs>
            </Box>

            <CustomTabPanel value={value} index={0}>
              <Suspense
                fallback={
                  <Box width={"100%"} pt={5} textAlign={"center"} py={5}>
                    <CircularProgress />
                  </Box>
                }
              >
                 <TreeAllOKR
                  periodId={periodId}
                  periodsData={perData}
                  dataa={objetcideData1}
                />
              </Suspense>
            </CustomTabPanel>
            
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Index